import { useState } from 'react';

import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchDateRangeForm } from 'src/components/common/form/search/SearchDateRangeForm';
import { SearchInputForm } from 'src/components/common/form/search/SearchInputForm';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useTQC1040_R01Store } from './Store_TQC1040_R01';

interface Props {
	onEnterKeyDown: () => void;
}

// 사업장·입고기간·약품유형·약품코드 조회조건을 입력하는 영역을 렌더링한다.
export const SearchSection_TQC1040_R01 = ({ onEnterKeyDown }: Props) => {
	const { TQC1040_R01Filter, setTQC1040_R01Filter } = useTQC1040_R01Store();
	const { compCdList, chemicalTypeList } = useCommonCodeStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={TQC1040_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(item) => setTQC1040_R01Filter({ compCd: item?.compCd || '' })}
			/>

			<SearchDateRangeForm
				label="입고기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC1040_R01Filter.inspectDt}
				setDateRange={(range) => setTQC1040_R01Filter({ inspectDt: range })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<SearchDropDownForm
				label="약품유형"
				value={TQC1040_R01Filter.equipmentType || ''}
				optionList={chemicalTypeList}
				onChangeItem={(item) => setTQC1040_R01Filter({ equipmentType: item?.minorCd || '' })}
			/>

			<SearchInputForm
				label="약품코드"
				value={TQC1040_R01Filter.equipmentCd}
				onChange={(e) => setTQC1040_R01Filter({ equipmentCd: e.target.value.toUpperCase() })}
				onKeyDown={(e) => e.key === 'Enter' && onEnterKeyDown()}
				initValue={() => setTQC1040_R01Filter({ equipmentCd: '' })}
			/>
		</SearchSectionForm>
	);
};
